import type { ComponentProps } from 'react';
import { createContext } from 'react';
import type { ItandiHeader } from '@itandi/brand-ui/ItandiHeader';
import type { Staff } from './Staff';
import type { CompanySetting } from './CompanySetting';
import type { CompanyStoreSetting } from './CompanyStoreSetting';

export type ItandiAccount = {
  company: CompanySetting | null;
  staff: Staff | null;
  store: CompanyStoreSetting | null;
  isAdmin: boolean;
  productParams: ComponentProps<typeof ItandiHeader>['productMenus'];
};

const defaultItandiAccount = {
  company: null,
  staff: null,
  store: null,
  isAdmin: false,
  productParams: []
};

export const ItandiAccountContext =
  createContext<ItandiAccount>(defaultItandiAccount);
